import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Markdown from 'react-markdown';
import gfm from 'remark-gfm';
import config from '../../config';

const Condition = (props) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const id = location.pathname.split('/').pop();

  const findCondition = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${config.REACT_APP_API_URL}/page/${id}`,{
            headers: { 
            'x-api-key': config.SITE_API_KEY
           }});
      console.log('API response:', response.data); // Pour déboguer
      const { title, description } = response.data.result || {};
      setTitle(typeof title === 'string' ? title : '');
      setDescription(typeof description === 'string' ? description : '');
    } catch (error) {
      console.error('Error fetching condition:', error);
      setError(error.message);
      toast.error(<b>Erreur lors du chargement de la condition : {error.message}</b>);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    findCondition();
  }, [id]);

  // Définir les styles pour chaque niveau de titre
  const markdownComponents = {
    h1: ({ node, ...props }) => (
      <h1 className="text-darkgray text-3xl font-bold" {...props} />
    ),
    h2: ({ node, ...props }) => (
      <h2 className="text-[#232323]" {...props} />
    ),
    h3: ({ node, ...props }) => (
      <h3 className="text-blue-600 font-medium" {...props} />
    ),
    h4: ({ node, ...props }) => (
      <h4 className="text-red-600 text-lg font-normal" {...props} />
    ),
    p: ({ node, ...props }) => (
      <p className="text-gray-700" {...props} />
    ),
  };

  return (
    <div style={props.style}>
      <Container className="my-20 p-20">
        {loading ? (
          <p>Chargement...</p>
        ) : error ? (
          <p className="text-red-500">Erreur : {error}</p>
        ) : (
          <>
            <div className="text-xl uppercase text-center ml-[4%]">
              {typeof title === 'string' && title ? (
                <Markdown remarkPlugins={[gfm]} components={markdownComponents}>
                  {title}
                </Markdown>
              ) : (
                <p>Titre non disponible</p>
              )}
            </div>
            <div className="mt-4">
              {typeof description === 'string' && description ? (
                <Markdown remarkPlugins={[gfm]} components={markdownComponents}>
                  {description}
                </Markdown>
              ) : (
                <p>Description non disponible</p>
              )}
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default Condition;